import { FetchAPI } from "@renedelangel/helpers";
import { urlServidor } from '../../helpers';
import { GET_ALL_USUARIO } from '../Usuarios';

/* Catálogos de solo lectura para los seguimientos de seguros */

export const GET_ALL_EJERCICIOSEGUROS = `
query filtroGetAll($filtro: InputGetEjercicioSeguros){
    getAllEjercicioSeguros(filtro: $filtro){
        ejercicioID
        descripcion
        fechaInicio
        fechaFin
        estado
    }
}
`;

export const GET_ALL_SEMANASEGUROS = `
query filtroGetAll($filtro: InputGetSemanaSeguros){
    getAllSemanaSeguros(filtro: $filtro){
        semanaID
        ejercicioID
        ejercicio
        numSemana
        fechaInicio
        fechaFin
        estado
    }
}
`;

export const GET_ALL_ESTADOSEGUIMIENTO = `
query filtroGetAll($filtro: InputGetEstadoSeguimiento){
    getAllEstadoSeguimiento(filtro: $filtro){
        estadoID
        nombre
        color
        esFinal
        orden
    }
}
`;

export const getAllEjercicioSeguros = async (variables, token) => {
    try {
        let { getAllEjercicioSeguros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_EJERCICIOSEGUROS
        });
        return getAllEjercicioSeguros;
    } catch ({ message }) { throw new Error(message); }
}

export const getAllSemanaSeguros = async (variables, token) => {
    try {
        let { getAllSemanaSeguros } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_SEMANASEGUROS
        });
        return getAllSemanaSeguros;
    } catch ({ message }) { throw new Error(message); }
}

export const GET_ALL_TIPOSEGUIMIENTO = `
query filtroGetAll($filtro: InputGetTipoSeguimiento){
    getAllTipoSeguimiento(filtro: $filtro){
        tipoSeguimientoID
        nombre
        orden
    }
}
`;

export const getAllTipoSeguimiento = async (variables, token) => {
    try {
        let { getAllTipoSeguimiento } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_TIPOSEGUIMIENTO
        });
        return getAllTipoSeguimiento;
    } catch ({ message }) { throw new Error(message); }
}

export const seleccionTipoSeguimiento = async (variables, token) => {
    try {
        let allTipos = await getAllTipoSeguimiento(variables, token);
        if (!Array.isArray(allTipos)) throw new Error("No se encontraron registros");

        return allTipos.map(({ tipoSeguimientoID: value, nombre: label }) => ({ value, label: String(label).toUpperCase() }));
    } catch ({ message: label }) {
        return [{ label, value: null, disabled: true }];
    }
}

export const getAllEstadoSeguimiento = async (variables, token) => {
    try {
        let { getAllEstadoSeguimiento } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_ESTADOSEGUIMIENTO
        });
        return getAllEstadoSeguimiento;
    } catch ({ message }) { throw new Error(message); }
}

export const seleccionEjercicioSeguros = async (variables, token) => {
    try {
        let allEjercicios = await getAllEjercicioSeguros(variables, token);
        if (!Array.isArray(allEjercicios)) throw new Error("No se encontraron registros");

        return allEjercicios.map(({ ejercicioID: value, descripcion: label, fechaInicio, fechaFin, estado }) => ({
            value,
            label: String(label).toUpperCase(),
            fechaInicio,
            fechaFin,
            estado
        }));
    } catch ({ message: label }) {
        return [{ label, value: null, disabled: true }];
    }
}

export const seleccionSemanaSeguros = async (variables, token) => {
    try {
        let allSemanas = await getAllSemanaSeguros(variables, token);
        if (!Array.isArray(allSemanas)) throw new Error("No se encontraron registros");

        return allSemanas.map(({ semanaID: value, numSemana, ejercicioID, fechaInicio, fechaFin, estado }) => ({
            value,
            label: `SEMANA ${numSemana}`,
            ejercicioID,
            numSemana,
            fechaInicio,
            fechaFin,
            estado
        }));
    } catch ({ message: label }) {
        return [{ label, value: null, disabled: true }];
    }
}

export const seleccionEstadoSeguimiento = async (variables, token) => {
    try {
        let allEstados = await getAllEstadoSeguimiento(variables, token);
        if (!Array.isArray(allEstados)) throw new Error("No se encontraron registros");

        return allEstados.map(({ estadoID: value, nombre: label, color, esFinal }) => ({
            value,
            label: String(label).toUpperCase(),
            color,
            esFinal
        }));
    } catch ({ message: label }) {
        return [{ label, value: null, disabled: true }];
    }
}

export const seleccionUsuarios = async (variables, token) => {
    try {
        let { getAllUsuario } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: GET_ALL_USUARIO
        });
        if (!Array.isArray(getAllUsuario)) throw new Error("No se encontraron registros");

        return getAllUsuario.map(({ usuarioID: value, usuario: label }) => ({ value, label: String(label).toUpperCase() }));
    } catch ({ message: label }) {
        return [{ label, value: null, disabled: true }];
    }
}
